import { Section, Wrapper } from '@ahmdigital/ui';
import styled from 'styled-components';

const StyledSection = styled(Section)`
  padding: 3rem;
`;

const AlertWrapper = styled(Wrapper)`
  padding-top: 3rem;
`;

const StyledWrapper = styled(Wrapper)`
  padding-top: 2rem;
  padding-bottom: 6rem;
`;

export { StyledSection, AlertWrapper, StyledWrapper };
